<div class="row d-none d-md-block bg-light">
  <div class="col-12">
    <div class="row py-4">
      <div class="col-12 text-center">
        <h1 class="mb-0 font-weight-bold">{{'wizard.heading' | translate}}</h1>
      </div>
    </div>
    <div class="row pb-4">
      <div class="col-12">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <ul class="nav nav-fill wizard px-0 w-100">
                @for (step of steps; track step; let index = $index) {
                <li
                  [innerHTML]="'wizard.steps.' + index + '.label' | translate: {'number': index + 1}"
                  [class.nav-item-active]="isCurrentStep(step)"
                  class="nav-item mr-1 pt-1 text-center font-weight-bold"
                ></li>
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>

<div class="container">
  <div class="row">
    <div class="col-12">
      <p>{{materialId}}</p>
    </div>
  </div>
</div>
